






































import Vue from 'vue';
import axios from 'axios';
import VariableInput from '@/components/util/VariableInput.vue';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import {
  passwordConstraintMessage,
  passwordConstraintErrorMessage, 
  passwordRegExp, 
} from '@/views/forms/constraint';
import { changePassword } from '@/api/UserProfile';

export default Vue.extend({
  name: 'CorpPasswordChange',
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    'accountData.oldPassword'(password: string) {
      this.inputs['oldPassword'].error = password ? '' : '現在のパスワードを入力してください';
    },
    'accountData.newPassword'(password: string) {
      this.inputs['newPassword'].error = passwordRegExp.test(password) ? '' : passwordConstraintErrorMessage;
    },
  },
  data() {
    return {
      accountData: {
        oldPassword: '',
        newPassword: '',
      },
      inputs: {
        'oldPassword': { name: '現在のパスワード', type: 'password', constraint: passwordConstraintMessage, placeholder: '現在のパスワード', error: '' },
        'newPassword': { name: '新しいパスワード', type: 'password', constraint: passwordConstraintMessage, placeholder: '新しいパスワード', error: '' },
      },
    }
  },
    computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.accountData.oldPassword && passwordRegExp.test(this.accountData.newPassword));
    },
  },
  methods: {
    async onClickSubmit() {
      try {
        await changePassword({
          oldPassword: this.accountData.oldPassword,
          newPassword: this.accountData.newPassword,
        });
        this.toAccountSettings();
        this.$emit('toast', 'パスワードを更新しました');
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          this.$emit('errorToast', e.response.data.message);
          return;
        }
        this.$emit('errorToast', 'パスワードの変更に失敗しました。');
      }
    },
    toAccountSettings() {
      this.$router.push({name:'AccountInfo'});
    },
  }
})
